__turbopack_context__.v({
  "flexContent": "Zm3Uqa_flexContent",
  "flexContentGap12": "Zm3Uqa_flexContentGap12",
  "flexContentGap16": "Zm3Uqa_flexContentGap16",
  "flexContentGap8": "Zm3Uqa_flexContentGap8",
  "itemOption": "Zm3Uqa_itemOption",
  "itemOptionContent": "Zm3Uqa_itemOptionContent",
  "itemOptionTag": "Zm3Uqa_itemOptionTag",
  "itemOptionTrailing": "Zm3Uqa_itemOptionTrailing",
  "itemOptionTwoLinesContentWrapper": "Zm3Uqa_itemOptionTwoLinesContentWrapper",
  "itemOptionWrapper": "Zm3Uqa_itemOptionWrapper",
  "optionItemsContainer": "Zm3Uqa_optionItemsContainer",
  "optionPrice": "Zm3Uqa_optionPrice",
  "optionPriceSinglePrice": "Zm3Uqa_optionPriceSinglePrice",
  "optionValue": "Zm3Uqa_optionValue",
});
